export default "__VITE_ASSET__nth_UwEV__"